import React from "react";
import autobind from "autobind-decorator";
import {Row} from "react-bootstrap";

import {MutableList} from "./MutableList";
import {HelpIcon} from "./HelpIcon";
import {StreamBankEditableCheckerEnhance} from "./Enhancements";
import {Glyphicon} from "./GlyphIcon";

@StreamBankEditableCheckerEnhance
export class StreamBankPermitConservationActionList extends MutableList {

    // TODO: we should be able to remove this method after implementing SB-1489?
    @autobind
    getData() {
        const data = super.getData();

        return data.filter(x => this.props.EditableChecker.CanEditContextNodeId(x.contextNodeId) || !x.contextNodeId);
    }

    @autobind
    isEditable(item) {
        return this.props.Editable && !item.contextNodeId;
    }

    // this method determines which ConservationActions are excluded from the autocomplete search box
    @autobind
    filter(data, selectedModel) {
        const organizationId = this.props?.AdditionalTypeProps?.RootData?.organizationId;

        // these ConservationActions are already assigned to this Permit
        // (excluding the one that is already selected in this current input)
        const alreadyAssigned = this.getData().map(({conservationActionId}) => conservationActionId)
            .filter(conservationActionId => conservationActionId !== selectedModel?.conservationActionId);

        return data.filter((conservationAction) => {
            // exclude ConservationActions that
            // 1. are in a different organization (for TFT staff)
            // 2. are already assigned in another row of the repeater
            // 3. the user cannot edit
            return conservationAction?.organizationId === organizationId
                && !alreadyAssigned.includes(conservationAction.conservationActionId)
                // TODO: we should be able to remove the EditableChecker part of this method after implementing SB-1489?
                && this.props.EditableChecker.CanEditContextNodeId(conservationAction.contextNodeId)
        });
    }

    render() {
        return (
            <div>
                { this.props.children }
                {
                    this.getData() ?
                        this.getData().map((x) =>
                            <Row key={this.props.GetItemKey(x)} className="pop-row">
                                <div className="pop-col">
                                    <this.props.Type
                                        Key={this.props.GetItemKey(x)}
                                        Item={x}
                                        UpdateItem={(value) => this.props.UpdateItem(this.props.GetItemKey(x), value)}
                                        {...this.props.AdditionalTypeProps}
                                        Editable={this.isEditable(x)}
                                        CustomData={{filter: this.filter}}
                                    />
                                </div>
                                {
                                    this.isEditable(x) && !x.isAssigned ?
                                        <div className="remove-table pop-remove">
                                            <a className="pndlm-remove-control" onClick={() => this.props.RemoveItem(this.props.GetItemKey(x))}>
                                                <Glyphicon glyph="remove-sign" />
                                            </a>
                                        </div> :
                                        <div className="remove-table pop-remove">
                                            <HelpIcon id={"help-icon-" + x.conservationActionId}>
                                                This Conservation Action is assigned from the Permits Survey page. To remove it, click on the Conservation Action name and remove it from the corresponding section in the Survey.
                                            </HelpIcon>
                                        </div>
                                }
                            </Row>
                        ) :
                        null
                }
                {
                    this.props.Editable ?
                        <Row className="pop-row">
                            <div className="add-table pop-add">
                                <a className="pndlm-remove-control" onClick={() => this.props.AddItem()}>
                                    <Glyphicon glyph="plus-sign" />
                                </a>
                            </div>
                        </Row> :
                        null
                }
            </div>
        );
    }
}
